import { render, staticRenderFns } from "./transportOil.vue?vue&type=template&id=16c2b6cd&scoped=true&"
import script from "./transportOil.vue?vue&type=script&lang=js&"
export * from "./transportOil.vue?vue&type=script&lang=js&"
import style0 from "./transportOil.vue?vue&type=style&index=0&id=16c2b6cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2b6cd",
  null
  
)

export default component.exports